import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextArea } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function PlayItOutDecidePage() {
  const [week1, setWeek1] = useState('');
  const [week2, setWeek2] = useState('');
  const [week3, setWeek3] = useState('');
  const [week4, setWeek4] = useState('');
  const [story, setStory] = useState('');
  const [reflections, setReflections] = useState('');

  return (
    <TaskPage
      phase="decide"
      title="Play It Out"
      pageNumber={5}
      instruction="Build your next 30 days as a priority map. Lanes = weeks; blocks = efforts sized by time/impact. Place blocks for the 3–6 most important items."
      whyItMatters="Low-stakes making + storytelling unlocks meaning and recall; the debrief consolidates learning and surfaces commitment."
      coachRail={{
        timing: "10-15 minutes",
        tips: "Build (3-5 min), then Story (pairs, 2 min each), then Reflect (team, 3-5 min).",
        debrief: "What was hard to cut? Which rule helped most?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Build: Priority Map (3-5 min)</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">Lanes = weeks; blocks = efforts sized by time/impact</p>
          <div className="grid grid-cols-4 gap-4">
            <div className="border border-[var(--rule)] rounded p-3">
              <h4 className="text-sm font-semibold mb-2">Week 1</h4>
              <TextArea
                value={week1}
                onChange={(e) => setWeek1(e.target.value)}
                placeholder="Place blocks here..."
                rows={6}
                className="text-xs"
              />
            </div>
            <div className="border border-[var(--rule)] rounded p-3">
              <h4 className="text-sm font-semibold mb-2">Week 2</h4>
              <TextArea
                value={week2}
                onChange={(e) => setWeek2(e.target.value)}
                placeholder="Place blocks here..."
                rows={6}
                className="text-xs"
              />
            </div>
            <div className="border border-[var(--rule)] rounded p-3">
              <h4 className="text-sm font-semibold mb-2">Week 3</h4>
              <TextArea
                value={week3}
                onChange={(e) => setWeek3(e.target.value)}
                placeholder="Place blocks here..."
                rows={6}
                className="text-xs"
              />
            </div>
            <div className="border border-[var(--rule)] rounded p-3">
              <h4 className="text-sm font-semibold mb-2">Week 4</h4>
              <TextArea
                value={week4}
                onChange={(e) => setWeek4(e.target.value)}
                placeholder="Place blocks here..."
                rows={6}
                className="text-xs"
              />
            </div>
          </div>
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Story: Why You Chose/Cut (Pairs, 2 min each)</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">Tell why you chose/cut items (cite criteria)</p>
          <TextArea
            label="Your story"
            value={story}
            onChange={(e) => setStory(e.target.value)}
            placeholder="Why did you choose these items? What did you cut and why? Cite your criteria..."
            rows={5}
          />
        </div>

        <div className="bg-[var(--green-dim)] border border-[var(--green)] p-6">
          <h3 className="text-lg font-semibold text-[var(--green)] dark:text-[var(--text-ter)] mb-4">Reflect: What Was Hard? (Team, 3-5 min)</h3>
          <TextArea
            label="Reflection notes"
            value={reflections}
            onChange={(e) => setReflections(e.target.value)}
            placeholder="What was hard to cut? Which rule helped most? What patterns do you see?"
            rows={5}
          />
        </div>

        <Callout type="tip" phase="decide">
          <p className="text-sm">Use physical or digital cards/blocks to visualize. This helps everyone see the full picture.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






